/**
 * Application configuration
 * This file contains configuration settings for the application
 */

import { StickerConfiguration } from "@/types/stock";

// Logo configuration
export const logoConfig = {
  // Path to the logo image (can be jpg, png, or webp)
  // This path is relative to the public directory
  path: "/logo.png",

  // Alternative text for the logo
  alt: "Repair Shop Logo",

  // Logo dimensions
  width: 120,
  height: 120,
};

export const logoPrintConfig = {
  // Path to the logo image (can be jpg, png, or webp)
  // This path is relative to the public directory
  path: "/logo-print.png",

  // Alternative text for the logo
  alt: "Repair Shop Logo",

  // Logo dimensions
  width: 120,
  height: 120,
};

// App configuration
export const appConfig = {
  // Company/app name
  name: "Repair QR Ninja",

  // Default currency
  currency: "TND",

  // Other app-wide settings can be added here
};

// Default sticker configuration for product labels
export const defaultStickerConfig: StickerConfiguration = {
  paperSize: "40x20mm",
  dimensions: {
    width: 40,
    height: 20,
  },
  displayOptions: {
    showProductName: true,
    showSKU: true,
    showPrice: true,
    showBarcode: true,
    showCategory: false,
    showDescription: false,
  },
  fontSize: {
    productName: 7,
    price: 6,
    sku: 5,
    other: 5,
  },
  barcodeHeight: 8,
  margin: 1,
};

// Predefined sticker size presets
export const stickerSizePresets: Record<
  string,
  { width: number; height: number; label: string }
> = {
  "40x20mm": { width: 40, height: 20, label: "40mm × 20mm (Small)" },
  "50x30mm": { width: 50, height: 30, label: "50mm × 30mm (Medium)" },
  "50x40mm": { width: 50, height: 40, label: "50mm × 40mm (Large)" },
  "60x40mm": { width: 60, height: 40, label: "60mm × 40mm (Extra Large)" },
};
